import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { PageNames } from 'src/app/configs/page-names.enum';
import {
  CustomResultOfPaginatedListOfGetCheckNumberClassResponsesWithPaginationDto,
  GetCheckNumberClassResponsesWithPaginationDto,
} from 'src/app/core/api/models';
import { CheckNumberClassResponsesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';

@Component({
  selector: 'app-check-number-class-responses',
  templateUrl: './check-number-class-responses.component.html',
  imports: [BaseIndexModule],
})
export class CheckNumberClassResponsesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.checkNumberClassResponses;
  modelWithPagination$: Observable<CustomResultOfPaginatedListOfGetCheckNumberClassResponsesWithPaginationDto>;
  items$: Observable<Array<GetCheckNumberClassResponsesWithPaginationDto>>;

  // binding component CRUD endpoints
  protected currentService = inject(CheckNumberClassResponsesService);
  paginationApiMethodName: string =
    this.currentService
      .checkNumberClassResponsesGetCheckNumberClassResponsesWithPagination.name;
  // binding component CRUD endpoints

  //#endregion

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.showHelpBtn = true;
      this.pageConfig.tableConfig.showOperationColumn = false;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  override setDefaultTableSort() {
    try {
      //اگر از قبل مقدار وجود داشت دیگه push نکنه
      const isExistsSortObject = this.sortObject.some((item) =>
        item.columnName.includes('checkTime')
      );
      if (!isExistsSortObject)
        this.sortObject.push({ columnName: 'checkTime', sort: 1 });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: 'common.mobile',
        name: 'mobile',
        hasSearch: true,
      },
      {
        title: 'common.userName',
        name: 'userName',
        hasSearch: true,
      },
      {
        title: this.localizer.organizationName,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}checkTime`,
        name: 'checkTime',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }
}
